// Shared helpers for order statuses
export const ORDER_STATUSES = [
    "pendente",
    "paga",
    "em_preparacao",
    "enviada",
    "em_transito",
    "entregue",
    "cancelada",
    "reembolsada",
];

export const ORDER_STATUS_LABELS = {
    pendente: "Pendente",
    paga: "Paga",
    em_preparacao: "Em preparação",
    enviada: "Enviada",
    em_transito: "Em trânsito",
    entregue: "Entregue",
    cancelada: "Cancelada",
    reembolsada: "Reembolsada",
};

export const ORDER_STATUS_STYLES = {
    pendente: "bg-brand-cream text-brand-ink",
    paga: "bg-brand-green-soft text-brand-green",
    em_preparacao: "bg-brand-yellow text-[#8a6b00]",
    enviada: "bg-brand-orange-soft text-brand-orange",
    em_transito: "bg-blue-100 text-blue-700",
    entregue: "bg-brand-green text-white",
    cancelada: "bg-red-100 text-red-700",
    reembolsada: "bg-gray-200 text-gray-700",
};

export const formatDateTime = (iso) => {
    if (!iso) return "—";
    try {
        return new Intl.DateTimeFormat("pt-PT", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        }).format(new Date(iso));
    } catch {
        return iso;
    }
};

// States considered "ainda não enviadas" for the SLA alert
export const PENDING_STATUSES = new Set([
    "pendente",
    "paga",
    "em_preparacao",
]);

export const PENDING_ALERT_DAYS = 3;

// Returns null if no alert, otherwise { days, level: "warn" | "danger" }
export const getPendingAlert = (order, thresholdDays = PENDING_ALERT_DAYS) => {
    if (!order || !order.created_at) return null;
    if (!PENDING_STATUSES.has(order.order_status)) return null;
    const createdAt = new Date(order.created_at);
    if (isNaN(createdAt.getTime())) return null;
    const diffMs = Date.now() - createdAt.getTime();
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (days < thresholdDays) return null;
    const level = days >= thresholdDays * 2 ? "danger" : "warn";
    return { days, level };
};

export const formatPrice = (value, currency = "EUR") => {
    try {
        return new Intl.NumberFormat("pt-PT", {
            style: "currency",
            currency: (currency || "EUR").toUpperCase(),
        }).format(Number(value || 0));
    } catch {
        return `${value} €`;
    }
};
